import React from 'react'
import Paper from '@material-ui/core/Paper'
import Card from '@material-ui/core/Card'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import _ from 'lodash'
import uuid from 'uuid/v4'
import Slide from '@material-ui/core/Slide';

const styles = theme  => {
    return ({
    paper: {
        padding: theme.spacing.unit*2,
        marginBottom: theme.spacing.unit,
      },
    paperContent: {
        marginTop: theme.spacing.unit*2
        

      },
    card: {
          padding: theme.spacing.unit,
          marginBottom: theme.spacing.unit,
          textAlign: 'center',
          borderBottom: '1px solid '+ theme.palette.primary.light
      },
    headline: {
          boxShadow: '2px 2px 2px',
         // textTransform: 'uppercase'
         paddingBottom: '4px'

      },
      lableWrapper: {
          textAlign: 'left'
      },
      lable: {
          fontSize: '0.7422em',
          fontWeight: 'bold'
          
          
      }

})}
const PaperCardList = (props) => {
  
    const {renderProps, classes} = props
    const {headline, withLable, content} = renderProps

    //render items
    const renderItems = _.map(content, dataItem =>
        <Slide key={uuid()} direction="left" in={true} mountOnEnter unmountOnExit>
            <Card className={classes.card}>
            {withLable
                ? <div className={classes.lableWrapper}>
                    <Typography variant='button' className={classes.lable}>
                        {dataItem.lable}
                    </Typography>
                </div>
                : null}
                <Typography 
                    color='primary' variant='subheading'>
                    {dataItem.value}
                </Typography>
            </Card>
        </Slide>
      
        )

    return (
            <Paper className={classes.paper}>
                <Typography className={classes.headline} variant="title" color='primary' gutterBottom>{headline}</Typography>
                <div className={classes.paperContent}>
                    {renderItems}
                </div>
            </Paper>
    )

}

export default withStyles(styles)(PaperCardList)


// WEBPACK FOOTER //
// ./src/Container/Content/PaperCardList.js